import { render } from "./CreateCurrencyModal.vue?vue&type=template&id=f0bc911c&scoped=true&ts=true"
import script from "./CreateCurrencyModal.vue?vue&type=script&lang=ts"
export * from "./CreateCurrencyModal.vue?vue&type=script&lang=ts"

import "./CreateCurrencyModal.vue?vue&type=style&index=0&id=f0bc911c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0bc911c"]])

export default __exports__